export default class TestKvizSave {
  // Extract current state of test quiz
  static getData(target) {
    const testQuizId = target.getAttribute('data-test-quiz-id') || target.id;
    const $items = target.querySelectorAll('.test-quiz-item');

    const questions = Array.from($items).map(($item, index) => {
      const $selectedOption = $item.querySelector('.option.selected');
      const selectedIndex = $selectedOption
        ? Array.from($item.querySelectorAll('.option')).indexOf($selectedOption)
        : null;

      return {
        questionIndex: index,
        selectedAnswer: selectedIndex,
        answered: selectedIndex !== null,
      };
    });

    return {
      id: testQuizId,
      questions,
    };
  }

  // Restore test quiz state from saved data
  static loadData(target, data) {
    if (!data || !data.questions) {
      console.warn('TestKvizSave: No valid data to load');
      return;
    }

    const $items = target.querySelectorAll('.test-quiz-item');

    data.questions.forEach((questionData) => {
      const $item = $items[questionData.questionIndex];
      if (!$item) return;

      const $options = $item.querySelectorAll('.option');

      // Clear all selections first
      $options.forEach(($option) => {
        $option.classList.remove('selected');
      });

      // Set selected answer if exists
      if (questionData.selectedAnswer !== null && $options[questionData.selectedAnswer]) {
        $options[questionData.selectedAnswer].classList.add('selected');
      }
    });
  }
}
